import { useEffect, useState } from "react";

import { CancelDowngradeScheduleModal } from "@/react/components/SettingsApp/Plan/PlanSettings/shared/CancelDowngradeScheduleModal";

import { useCancelDowngradeScheduledHandler } from "./hooks/useCancelDowngradeScheduledHandler";
import type { CancelScheduledDowngradeModalSource } from "./types";

interface CancelDowngradeScheduleWrapperProps {
  hideModal: () => void;
  source: CancelScheduledDowngradeModalSource;
}

export const CancelDowngradeScheduleWrapper = ({
  source,
  hideModal,
}: CancelDowngradeScheduleWrapperProps) => {
  const {
    isScheduledDowngradeActive,
    handleCancelScheduledDowngrade,
    getModalConfig,
  } = useCancelDowngradeScheduledHandler({ source });

  const [modalKey, setModalKey] = useState(0);

  useEffect(() => {
    if (isScheduledDowngradeActive) {
      setModalKey(prev => prev + 1);
    }
  }, [isScheduledDowngradeActive]);

  if (!isScheduledDowngradeActive) {
    return null;
  }

  const modalConfig = getModalConfig();

  const handleConfirm = () => {
    handleCancelScheduledDowngrade(() => {
      hideModal();
    });
  };

  return (
    <CancelDowngradeScheduleModal
      key={modalKey}
      showModal
      onClose={hideModal}
      onConfirm={handleConfirm}
      title={modalConfig.title}
      confirmText={modalConfig.confirmText}
      description={modalConfig.description}
    />
  );
};
